<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="学校名称" prop="dname">
							<el-select v-model="formParameter.dname" clearable placeholder="请选择学校">
								<el-option v-for="item in schoolSelect" :key="item" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="减免金额" prop="cost"><el-input v-model="formParameter.cost"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="条件金额" prop="maximum"><el-input v-model="formParameter.maximum"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="开始时间" prop="starttime">
							<el-date-picker v-model="formParameter.starttime" value-format="yyyy-MM-dd" type="date"
								placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="结束时间" prop="endtime">
							<el-date-picker v-model="formParameter.endtime" value-format="yyyy-MM-dd" type="date"
								placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="formParameter.image">
					<el-col :span="24">
						<el-image style="width: 600px; height: 300px;margin-left: 50px;" :src="formParameter.image"
							:preview-src-list="srcList">
						</el-image>
						<i  v-if="!disabled"  style="margin-left: 10px;" class="el-icon-circle-close" @click="updateImg()"> </i>
					</el-col>
				</el-row>
				<el-row v-else>
					<el-form-item label="上传图片:" prop="image">
						<el-col :span="24" class="userHead" style="margin-left: 30px;">
							<drag-file-upload  @change="change" v-model="formParameter.image" drag
								uri="/statics/voucher" model="fileSystem" :size="10240"></drag-file-upload>
							<div style=" font-weight: bold;">
							</div>
						</el-col>
					</el-form-item>
				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/voucher.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import apiSchools from '@/api/xueli/xlschool.js';
import dragFileUpload from '@/components/biz/fileUpload/dragFileUpload.vue';
import constant from '@/util/constant.js';

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,dragFileUpload,
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			srcList: [],
			formParameter: {},
			schoolSelect: [],
			BaseUrl:'',
			rules: {
				//代金券名字
				dname: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//代金券金额
				cost: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 10,
						trigger: 'blur'
					}
				],
				startTime: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
				],
				endTime: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
				],
			}
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		change() {
                 console.log(this.formParameter.image)
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//更新图片
		updateImg() {
			this.formParameter.image = null;
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
			      //保存相对地址
				if(this.formParameter.image && this.formParameter.image.indexOf("statics")>0){
						this.formParameter.image = this.formParameter.image.substring(this.formParameter.image.indexOf("statics")-1    )
				}

				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);
					api.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();

			this.BaseUrl = constant.serverUrl

			apiSchools.avibSkNames(null, response => {
				this.schoolSelect = response.data;
			})

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					this.formParameter = response.data;
					//补充回BaseUrl 
					if(this.formParameter.image ){
					   this.formParameter.image = this.BaseUrl + this.formParameter.image 
					}
					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;

			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
